import { EventFactory } from "applesauce-core/event-factory";

import { getEventRelayHint, getPubkeyRelayHint } from "./relay-hints";
import { NIP_89_CLIENT_APP } from "../const";
import accounts from "./accounts";
import localSettings from "./preferences";

const factory = new EventFactory({
  signer: accounts.signer,
  getEventRelayHint,
  getPubkeyRelayHint: getPubkeyRelayHint,
  client: localSettings.addClientTag.value ? NIP_89_CLIENT_APP : undefined,
});

// DEBUG: Wrap factory.sign to log events that fail validation
const originalSign = factory.sign.bind(factory);
factory.sign = async function (draft) {
  if (typeof (draft as any).content !== "string" || !Array.isArray((draft as any).tags)) {
    console.error("[event-factory] Draft missing content or tags before sign:", JSON.stringify(draft, null, 2));
  } else {
    const badTag = (draft as any).tags.find((t: any) => !Array.isArray(t) || t.some((v: any) => typeof v !== "string"));
    if (badTag) console.error("[event-factory] Draft has non-string tag before sign:", badTag, JSON.stringify(draft, null, 2));
  }
  return originalSign(draft);
};

// update event factory when settings change
localSettings.addClientTag.subscribe((client) => {
  if (client) factory.context.client = NIP_89_CLIENT_APP;
  else factory.context.client = undefined;
});

export default factory;
